<masonry [masonryItems]="masonryItems" [masonryColumnCount]="2"></masonry>
